import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AgentLayoutIndex from '../_layouts'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  cancel_policies: IJsonResponse
  user: IJsonResponse
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: true,
  },
  {
    name: I18n.t('activerecord.attributes.cancel_policy.name'),
    field: 'name_i18n',
    required: true,
  },
  {
    name: I18n.t('activerecord.attributes.cancel_policy.default_policy'),
    renderElement: record => record.default_policy.toString(),
    field: 'default_policy',
    required: false,
  },
]

const CancelPoliciesIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle(I18n.t('activerecord.models.cancel_policy'))
  const { data: cancel_policies } = utilService.getDataFromJson(props.cancel_policies)
  const { data: user } = utilService.getDataFromJson(props.user)

  return (
    <SidebarLayout user={user} showSidebar={true}>
      <AgentLayoutIndex
        model="cancel_policies"
        hideAgentNav={true}
        title={
          <Heading>
            <span>{I18n.t('activerecord.models.cancel_policy')}</span>
            <Button small={true}>
              <a href="/agent/cancel_policies/new">{I18n.t('generic.create_new')}</a>
            </Button>
          </Heading>
        }
        main={
          <>
            <EditTable
              editable={true}
              getEditLink={({ id }) => `/agent/cancel_policies/${id}/edit`}
              columns={COLUMNS}
              records={cancel_policies}
            />
          </>
        }
      />
    </SidebarLayout>
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default CancelPoliciesIndex
